"use client";
import { useDeviceType } from "@/hooks/useDeviceType";
import type { CasesProps } from "./types";
import CasesDesktop from "./CasesDesktop";
import CasesMobile from "./CasesMobile";

export const CasesBlock = ({ items }: CasesProps) => {
    const deviceType = useDeviceType();
    const isMobile = deviceType === "phone" || deviceType === "tablet";

    if (!items?.length) return null;

    const Component = isMobile ? CasesMobile : CasesDesktop;

    return (
        <div className="w-full">
            <Component items={items} />
        </div>
    );
};
